// 260930 Epic1-P3 — chip "Dàn cảnh" ở bước Kịch bản (PipelineStepper). Hàm THUẦN, KHÔNG import antd: dưới jest của react-scripts
// antd v6 + react-router-dom v7 không load được ⇒ logic phải tách khỏi file component (mẫu `promptChipUtils.ts`).
// Chip chỉ đếm READY / không READY. BE không trả cờ "tươi" ở `getEventPlanForUi` (tính hash lúc đọc thì tốn) ⇒ READY nhưng cũ
// vẫn tính là ready ở đây; cảnh báo `[staging-stale]` nằm ở prompt của event (TD ghi ở present/).
export interface StagingSummary { show: boolean; ready: number; total: number; missing: number }

const isReady = (staging: unknown): boolean =>
  !!staging && typeof staging === 'object' && !Array.isArray(staging) && (staging as { outcome?: unknown }).outcome === 'READY';

/** `show` = plan có dấu `stagingVersion` (plan cũ ⇒ không chip). `missing` = số event không READY (SKIPPED / chưa có). */
export function stagingSummary(events: Array<{ staging?: unknown }>, stagingVersion?: string | null): StagingSummary {
  const total = events.length;
  const ready = events.filter((e) => isReady(e?.staging)).length;
  return { show: stagingVersion != null, ready, total, missing: total - ready };
}

export function stagingChipLabel(s: StagingSummary): string {
  return `🎬 Dàn cảnh ${s.ready}/${s.total}${s.missing > 0 ? ` · ${s.missing} chưa` : ''}`;
}

export function stagingChipTone(s: StagingSummary): 'ok' | 'warn' {
  return s.missing > 0 ? 'warn' : 'ok';
}
